import { Link } from 'react-router-dom'
import { Section } from '@vanilla/ui'

export function Home() {
  return (
    <Section id="home" className="py-20 md:py-32">
      <div className="flex flex-col items-center text-center">
        {/* Headline */}
        <h1 className="mb-6 max-w-4xl text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl">
          KHC One
        </h1>

        {/* Tagline */}
        <p className="mb-12 text-lg text-muted-foreground md:text-xl">
          Music · Technology · Consulting
        </p>

        {/* Units Grid */}
        <div className="grid gap-6 sm:grid-cols-3">
          <Link
            to="/music"
            className="group flex flex-col items-center gap-4 rounded-2xl bg-card p-8 transition-all hover:-translate-y-1 hover:bg-card/80"
          >
            <span className="text-4xl">🎵</span>
            <h2 className="text-xl font-semibold">KHC Music</h2>
            <p className="text-sm text-muted-foreground">Artists & Releases</p>
          </Link>

          <Link
            to="/labs"
            className="group flex flex-col items-center gap-4 rounded-2xl bg-card p-8 transition-all hover:-translate-y-1 hover:bg-card/80"
          >
            <span className="text-4xl">⚡</span>
            <h2 className="text-xl font-semibold">KHC Labs</h2>
            <p className="text-sm text-muted-foreground">Apps & Systems</p>
          </Link>

          <Link
            to="/consulting"
            className="group flex flex-col items-center gap-4 rounded-2xl bg-card p-8 transition-all hover:-translate-y-1 hover:bg-card/80"
          >
            <span className="text-4xl">💼</span>
            <h2 className="text-xl font-semibold">KHC Consulting</h2>
            <p className="text-sm text-muted-foreground">IT Services</p>
          </Link>
        </div>
      </div>
    </Section>
  )
}
